import Breadcrumbs from 'my-components/Breadcrumbs';
import WizeLogo from 'my-components/WizeLogo';

import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ breakpoints, palette, spacing }) => ({
  position: 'relative',
  backgroundColor: palette.background.paper,
  padding: spacing(8, 8, 3),

  '.SSCH-progress': {
    position: 'absolute',
    height: 12,
    top: 0,
    left: 0,
    right: 0,
  },
  '.SSCH-header': {
    display: 'flex',
    alignItems: 'center',
    '& > * + *': { marginLeft: spacing(2) },
  },
  '.SSCH-img': { height: 44 },
  '.SSCH-spacer': { flex: 1 },
  '.SSCH-closeButton': {
    width: 48,
    position: 'absolute',
    top: 12,
    right: 8,
  },
  '.SSCH-breadcrumbs': { marginTop: spacing(1) },

  [breakpoints.only('xs')]: {
    padding: spacing(4, 2, 2),
  },
});

const BREADCRUMBS = ['Payment', 'Confirmation'];

export default function StudySessionCheckoutHeader({ activeStep, loading, onChangeStep, onClose }) {
  return (
    <div css={rootCss}>
      <LinearProgress className="SSCH-progress" {...(loading ? {} : { value: 100, variant: 'determinate' })} />
      <div className="SSCH-header">
        <WizeLogo className="SSCH-img" />
        <Typography variant="h5">Checkout</Typography>
        <div className="SSCH-spacer" />
        <IconButton className="SSCH-closeButton" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </div>
      <Breadcrumbs
        active={activeStep}
        className="SSCH-breadcrumbs"
        disabled={activeStep === BREADCRUMBS.length - 1 || loading}
        items={BREADCRUMBS}
        onChange={onChangeStep}
      />
    </div>
  );
}
